// extracted by mini-css-extract-plugin
export default {"confirmation__barcode":"Barcode_confirmation__barcode__+tFmp"};